import axiosService from './common/axiosSearch'

function selectRetrieve (paramData) {
	return axiosService.get('search/selectRetrieve', { params: paramData })
}

function selectBoardCnt (paramData) {
	return axiosService.get('search/selectBoardCnt', { params: paramData })
}

function insertSrchLang (paramData) {
	return axiosService.get('search/insertSrchLang', { params: paramData })
}

function selectSrchLang (paramData) {
	return axiosService.get('search/selectSrchLang', { params: paramData })
}

function selectDataMap (paramData) {
	return axiosService.post('search/dataMap', paramData)
}

function selectTagCount (paramData) {
	return axiosService.get('search/selectTagCount', { params: paramData })
}

function searchTagStatList (paramData) {
	return axiosService.get('search/searchTagStatList', { params: paramData })
}

function searchTagNoticeList (paramData) {
	return axiosService.get('search/searchTagNoticeList', { params: paramData })
}
function selectAutocomplete (paramData) {
  return axiosService.get('search/autocomplete', { params: paramData })
}

export { selectRetrieve, selectBoardCnt, insertSrchLang, selectSrchLang, selectDataMap, selectTagCount, searchTagStatList, searchTagNoticeList, selectAutocomplete }
